import styled from "styled-components";

export const PresentationButtonContainer = styled.button`
  border: none;
  border-radius: 4px;

  padding: 0.75rem 1.5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 0.5rem;

  font: 600 0.875rem/1rem "Inter";
  color: ${({ theme }) => theme.colors.textMasterColor} !important;
  line-height: 1.313rem;

  transition: all 0.2s ease-in-out;

  opacity: 0.9;

  background-color: ${({ theme }) => theme.colors.primary};

  width: fit-content;

  :hover:not(:disabled) {
    opacity: 1;
    cursor: pointer;
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }

  > svg * {
    stroke: ${({ theme }) => theme.colors.textMasterColor};
  }

  .loader,
  svg {
    height: 1.25rem;
    width: 1.25rem;
  }
`;

export const AlreadyHasAccessButtonContainer = styled.div`
  font: 400 0.875rem/1rem "Inter";
  color: ${({ theme }) => theme.colors.textMasterColor} !important;

  line-height: 1.313rem;
`;
